import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const ContainerPluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default ContainerPluginPage